import React, { useState } from "react";
import Logo from "./../../img/logo.png";
import { SidebarData } from "../../Data/Data";
import "./sidebar.css";
import { UilSignOutAlt, UilBars } from "@iconscout/react-unicons";
import { motion } from "framer-motion";

const SideBar = () => {
  const [select, setSelect] = useState(0);
  const [expanded, setExpanded] = useState(true);

  const sidebarVariants = {
    true: {
      left: "0",
    },
    false: {
      left: "-60%",
    },
  };

  return (
    <>
      <div
        className="menuIconCls"
        style={expanded ? { left: "60%" } : { left: "5%" }}
        onClick={() => setExpanded(!expanded)}
      >
        <UilBars />
      </div>
      <motion.div
        className="sidebar"
        variants={sidebarVariants}
        animate={window.innerWidth <= 768 ? `${expanded}` : ""}
      >
        <div className="logo">
          <img src={Logo} alt="logo" />
          <span>
            Sh<span>o</span>p
          </span>
        </div>
        <div className="menu">
          {SidebarData.map((item, index) => {
            return (
              <div
                key={index}
                className={select === index ? "menuItem active" : "menuItem"}
                onClick={() => setSelect(index)}
              >
                <item.icon />
                <span>{item.heading}</span>
              </div>
            );
          })}
          <div className="menuItem-bottom">
            <UilSignOutAlt />
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SideBar;
